import React, { useEffect } from "react";
import Footer from "containers/Footer";
import { useDispatch } from "react-redux";

import useStoreHandler from "hooks/useStoreHandler";

import deleteAllCookies from "utils/deleteAllCookies";

import PageLoading from "components/PageLoading";

const Logout = props => {
  const { resetStore, resetUserStore } = useStoreHandler(useDispatch());
  useEffect(() => {
    deleteAllCookies();
    resetUserStore();
    resetStore();
    console.log("store reset");
    setTimeout(() => {
      console.log("Setting Logout URL: ", process.env.REACT_APP_LOGOUT_URL);
      window.location.href = process.env.REACT_APP_LOGOUT_URL;
    }, 1000);
  }, []);

  return (
    <div className="app-main-container">
      <PageLoading />
      <Footer />
    </div>
  );
};

export default Logout;
